module.exports = __webpack_public_path__ + "static/media/Home Page_website-27.3a82f374.png";